"undefined" == typeof Shopify && (window.Shopify = {}), void 0 === Shopify.getCart && (Shopify.getCart = function(i, t) {
        t ? "function" == typeof i ? i(t) : "function" == typeof Shopify.onCartUpdate && Shopify.onCartUpdate(t) : jQuery.getJSON("/cart.js", function(t, e) {
            "function" == typeof i ? i(t) : Shopify.onCartUpdate(t)
        })
    }),
 function(t) {
    "use strict";
    t.ajaxChimp = {
        responses: {
            "We have sent you a confirmation email": 0,
            "Please enter a valid email": 1,
            "An email address must contain a single @": 2,
            "The domain portion of the email address is invalid (the portion after the @: )": 3,
            "The username portion of the email address is invalid (the portion before the @: )": 4,
            "This email address looks fake or invalid. Please enter a real email address": 5
        },
        translations: {
            en: null
        },
        init: function(e, i) {
            t(e).ajaxChimp(i)
        }
    }, t.fn.ajaxChimp = function(e) {
        return t(this).each(function(i, o) {
            var s = t(o),
                n = s.find("input[type=email]"),
                r = s.find(".info"),
                a = t.extend({
                    url: s.attr("action"),
                    language: "en"
                }, e),
                l = a.url.replace("/post?", "/post-json?").concat("&c=?");
            s.attr("novalidate", "true"), n.attr("name", "EMAIL"), s.submit(function() {
                function e(e) {
                    if ("success" === e.result) i = "We have sent you a confirmation email", r.removeClass("error").addClass("valid"), n.removeClass("error").addClass("valid");
                    else {
                        n.removeClass("valid").addClass("error"), r.removeClass("valid").addClass("error");
                        var o = -1;
                        try {
                            var s = e.msg.split(" - ", 2);
                            if (void 0 === s[1]) i = e.msg;
                            else {
                                var l = parseInt(s[0], 10);
                                l.toString() === s[0] ? (o = s[0], i = s[1]) : (o = -1, i = e.msg)
                            }
                        } catch (d) {
                            o = -1, i = e.msg
                        }
                    }
                    "en" !== a.language && void 0 !== t.ajaxChimp.responses[i] && t.ajaxChimp.translations && t.ajaxChimp.translations[a.language] && t.ajaxChimp.translations[a.language][t.ajaxChimp.responses[i]] && (i = t.ajaxChimp.translations[a.language][t.ajaxChimp.responses[i]]), r.html(i), r.show(2e3), a.callback && a.callback(e)
                }
                var i, o = {},
                    d = s.serializeArray();
                t.each(d, function(t, e) {
                    o[e.name] = e.value
                }), t.ajax({
                    url: l,
                    data: o,
                    success: e,
                    dataType: "jsonp",
                    error: function(t, e) {
                        console.log("mailchimp ajax submit error: " + e)
                    }
                });
                var c = "Submitting...";
                return "en" !== a.language && t.ajaxChimp.translations && t.ajaxChimp.translations[a.language] && t.ajaxChimp.translations[a.language].submit && (c = t.ajaxChimp.translations[a.language].submit), r.html(c).show(2e3), !1
            })
        }), this
    }
}(jQuery),
function() {
    var t, e, i, o, s, n, r = function(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    };
    e = function() {
        function t() {
            this.update = r(this.update, this)
        }
        return t.prototype.update = function(t) {
            var e, i, s;
            for (i in t) s = t[i], "items" !== i && (this[i] = s);
            return this.items = function() {
                var i, s, n, r;
                for (n = t.items, r = [], i = 0, s = n.length; i < s; i++) e = n[i], r.push(new o(e));
                return r
            }()
        }, t
    }(), o = function() {
        function t(t) {
            this.propertyArray = r(this.propertyArray, this), this.update = r(this.update, this), this.update(t)
        }
        return t.prototype.update = function(t) {
            var e, o;
            for (e in t) o = t[e], "properties" !== e && (this[e] = o);
            return this.properties = i.Utils.extend({}, t.properties)
        }, t.prototype.propertyArray = function() {
            var t, e, i, o;
            i = this.properties, o = [];
            for (t in i) e = i[t], o.push({
                name: t,
                value: e
            });
            return o
        }, t
    }(), i = {
        settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0
        },
        cart: new e
    }, i.init = function(t, e) {
        return null == e && (e = {}), i.configure(e), i.Utils.log("Initialising CartJS."), i.cart.update(t), i.settings.dataAPI && (i.Utils.log('"dataAPI" setting is true, initialising Data API.'), i.Data.init()), i.settings.requestBodyClass && (i.Utils.log('"requestBodyClass" set, adding event listeners.'), jQuery(document).on("cart.requestStarted", function() {
            return jQuery("body").addClass(i.settings.requestBodyClass)
        }), jQuery(document).on("cart.requestComplete", function() {
            return jQuery("body").removeClass(i.settings.requestBodyClass)
        })), i.Rivets.init(), jQuery(document).trigger("cart.ready", [i.cart])
    }, i.configure = function(t) {
        return null == t && (t = {}), i.Utils.extend(i.settings, t)
    }, null == window.console && (window.console = {}, window.console.log = function() {}), i.Utils = {
        log: function() {
            return i.Utils.console(console.log, arguments)
        },
        error: function() {
            return i.Utils.console(console.error, arguments)
        },
        console: function(t, e) {
            if (i.settings.debug && "undefined" != typeof console && null !== console) return e = Array.prototype.slice.call(e), e.unshift("[CartJS]:"), t.apply(console, e)
        },
        wrapKeys: function(t, e, i) {
            var o, s, n;
            null == e && (e = "properties"), n = {};
            for (o in t) s = t[o], n["" + e + "[" + o + "]"] = null != i ? i : s;
            return n
        },
        unwrapKeys: function(t, e, i) {
            var o, s, n, r;
            null == e && (e = "properties"), s = {};
            for (o in t) r = t[o], n = o.replace("" + e + "[", "").replace("]", ""), s[n] = null != i ? i : r;
            return s
        },
        extend: function(t, e) {
            var i, o;
            for (i in e) o = e[i], t[i] = o;
            return t
        },
        clone: function(t) {
            var e, i;
            if (null == t || "object" != typeof t) return t;
            i = new t.constructor;
            for (e in t) i[e] = clone(t[e]);
            return i
        },
        isArray: Array.isArray || function(t) {
            return "[object Array]" === {}.toString.call(t)
        },
        ensureArray: function(t) {
            return i.Utils.isArray(t) ? t : null != t ? [t] : []
        },
        formatMoney: function(t, e, o, s) {
            var n, r;
            return null == s && (s = ""), s || (s = i.settings.currency), null != window.Currency && s !== i.settings.currency && (t = Currency.convert(t, i.settings.currency, s), null != (null != (n = window.Currency) ? n.moneyFormats : void 0) && s in window.Currency.moneyFormats && (e = window.Currency.moneyFormats[s][o])), null != (null != (r = window.Shopify) ? r.formatMoney : void 0) ? Shopify.formatMoney(t, e) : t
        },
        getSizedImageUrl: function(t, e) {
            var i, o;
            return null != (null != (i = window.Shopify) && null != (o = i.Image) ? o.getSizedImageUrl : void 0) ? t ? Shopify.Image.getSizedImageUrl(t, e) : Shopify.Image.getSizedImageUrl("https://cdn.shopify.com/s/images/admin/no-image-.gif", e).replace("-_", "-") : t ? t : "https://cdn.shopify.com/s/images/admin/no-image-large.gif"
        }
    }, n = [], s = !1, i.Queue = {
        add: function(t, e, o) {
            var r;
            if (null == o && (o = {}), r = {
                    url: t,
                    data: e,
                    type: o.type || "POST",
                    dataType: o.dataType || "json",
                    success: i.Utils.ensureArray(o.success),
                    error: i.Utils.ensureArray(o.error),
                    complete: i.Utils.ensureArray(o.complete)
                }, o.updateCart && 
                    ("undefined" != typeof SECOMAPP ? $.proxy(r.success.push(function(e) {
                      Shopify.getCart(
                      function(t) {
                      !window.location.pathname.startsWith("/cart") || 
                      t.item_count 
                      === 
                      e.item_count 
                      &&
                      t.total_price 
                      ===
                      e.total_price 
                      &&
                      t.items.length 
                      ===
                      e.items.length ? (i.cart.update(t), jQuery(document).trigger("cart.requestComplete", [i.cart])) : window.location.reload(!0)
                      }, e)
                      
                   }), i, n) :

                    r.success.push(i.cart.update)), 

                    n.push(r), !s) return jQuery(document).trigger("cart.requestStarted", [i.cart]), i.Queue.process()
        },
        process: function() {
            var t;
            return n.length ? (s = !0, t = n.shift(), t.complete = i.Queue.process, jQuery.ajax(t)) : (s = !1, void jQuery(document).trigger("cart.requestComplete", [i.cart]))
        }
    }, i.Core = {
        getCart: function(t) {
            return null == t && (t = {}), t.type = "GET", t.updateCart = !0, i.Queue.add("/cart.js", {}, t)
        },
        addItem: function(t, e, o, s) {
            var n;
            return null == e && (e = 1), null == o && (o = {}), null == s && (s = {}), n = i.Utils.wrapKeys(o), n.id = t, n.quantity = e, i.Queue.add("/cart/add.js", n, s), i.Core.getCart()
        },
        updateItem: function(t, e, o, s) {
            var n;
            return null == o && (o = {}), null == s && (s = {}), n = i.Utils.wrapKeys(o), n.line = t, null != e && (n.quantity = e), s.updateCart = !0, i.Queue.add("/cart/change.js", n, s)
        },
        removeItem: function(t, e) {
            return null == e && (e = {}), i.Core.updateItem(t, 0, {}, e)
        },
        updateItemById: function(t, e, o, s) {
            var n;
            return null == o && (o = {}), null == s && (s = {}), n = i.Utils.wrapKeys(o), n.id = t, null != e && (n.quantity = e), s.updateCart = !0, i.Queue.add("/cart/change.js", n, s)
        },
        updateItemQuantitiesById: function(t, e) {
            return null == t && (t = {}), null == e && (e = {}), e.updateCart = !0, i.Queue.add("/cart/update.js", {
                updates: t
            }, e)
        },
        removeItemById: function(t, e) {
            var o;
            return null == e && (e = {}), o = {
                id: t,
                quantity: 0
            }, e.updateCart = !0, i.Queue.add("/cart/change.js", o, e)
        },
        clear: function(t) {
            return null == t && (t = {}), t.updateCart = !0, i.Queue.add("/cart/clear.js", {}, t)
        },
        getAttribute: function(t, e) {
            return t in i.cart.attributes ? i.cart.attributes[t] : e
        },
        setAttribute: function(t, e, o) {
            var s;
            return null == o && (o = {}), s = {}, s[t] = e, i.Core.setAttributes(s, o)
        },
        getAttributes: function() {
            return i.cart.attributes
        },
        setAttributes: function(t, e) {
            return null == t && (t = {}), null == e && (e = {}), e.updateCart = !0, i.Queue.add("/cart/update.js", i.Utils.wrapKeys(t, "attributes"), e)
        },
        clearAttributes: function(t) {
            return null == t && (t = {}), t.updateCart = !0, i.Queue.add("/cart/update.js", i.Utils.wrapKeys(i.Core.getAttributes(), "attributes", ""), t)
        },
        getNote: function() {
            return i.cart.note
        },
        setNote: function(t, e) {
            return null == e && (e = {}), e.updateCart = !0, i.Queue.add("/cart/update.js", {
                note: t
            }, e)
        }
    }, t = null, i.Data = {
        init: function() {
            return t = jQuery(document), i.Data.setEventListeners("on"), i.Data.render(null, i.cart)
        },
        destroy: function() {
            return i.Data.setEventListeners("off")
        },
        setEventListeners: function(e) {
            return t[e]("click", "[data-cart-add]", i.Data.add), t[e]("click", "[data-cart-remove]", i.Data.remove), t[e]("click", "[data-cart-remove-id]", i.Data.removeById), t[e]("click", "[data-cart-update]", i.Data.update), t[e]("click", "[data-cart-update-id]", i.Data.updateById), t[e]("click", "[data-cart-clear]", i.Data.clear), t[e]("change", "[data-cart-toggle]", i.Data.toggle), t[e]("change", "[data-cart-toggle-attribute]", i.Data.toggleAttribute), t[e]("submit", "[data-cart-submit]", i.Data.submit), t[e]("cart.requestComplete", i.Data.render)
        },
        add: function(t) {
            var e;
            return t.preventDefault(), e = jQuery(this), i.Core.addItem(e.attr("data-cart-add"), e.attr("data-cart-quantity"))
        },
        remove: function(t) {
            var e;
            return t.preventDefault(), e = jQuery(this), i.Core.removeItem(e.attr("data-cart-remove"))
        },
        removeById: function(t) {
            var e;
            return t.preventDefault(), e = jQuery(this), i.Core.removeItemById(e.attr("data-cart-remove-id"))
        },
        update: function(t) {
            var e;
            return t.preventDefault(), e = jQuery(this), i.Core.updateItem(e.attr("data-cart-update"), e.attr("data-cart-quantity"))
        },
        updateById: function(t) {
            var e;
            return t.preventDefault(), e = jQuery(this), i.Core.updateItemById(e.attr("data-cart-update-id"), e.attr("data-cart-quantity"))
        },
        clear: function(t) {
            return t.preventDefault(), i.Core.clear()
        },
        toggle: function(t) {
            var e, o;
            return e = jQuery(this), o = e.attr("data-cart-toggle"), e.is(":checked") ? i.Core.addItem(o) : i.Core.removeItemById(o)
        },
        toggleAttribute: function(t) {
            var e, o;
            return e = jQuery(this), o = e.attr("data-cart-toggle-attribute"), i.Core.setAttribute(o, e.is(":checked") ? "Yes" : "")
        },
        submit: function(t) {
            var e, o, s, n;
            return t.preventDefault(), e = jQuery(this).serializeArray(), o = void 0, n = void 0, s = {}, jQuery.each(e, function(t, e) {
                return "id" === e.name ? o = e.value : "quantity" === e.name ? n = e.value : s[e.name] = e.value
            }), i.Core.addItem(o, n, i.Utils.unwrapKeys(s))
        },
        render: function(t, e) {
            var o;
            return o = {
                item_count: e.item_count,
                total_price: e.total_price,
                total_price_money: i.Utils.formatMoney(e.total_price, i.settings.moneyFormat, "money_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0),
                total_price_money_with_currency: i.Utils.formatMoney(e.total_price, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", null != ("undefined" != typeof Currency && null !== Currency ? Currency.currentCurrency : void 0) ? Currency.currentCurrency : void 0)
            }, jQuery("[data-cart-render]").each(function() {
                var t;
                return t = jQuery(this), t.html(o[t.attr("data-cart-render")])
            })
        }
    }, "rivets" in window ? (i.Rivets = {
        model: null,
        boundViews: [],
        init: function() {
            return i.Rivets.bindViews()
        },
        destroy: function() {
            return i.Rivets.unbindViews()
        },
        bindViews: function() {
            return i.Utils.log("Rivets.js is present, binding views."), i.Rivets.unbindViews(), i.Rivets.model = i.Utils.extend({
                cart: i.cart
            }, i.settings.rivetsModels), null != window.Currency && (i.Rivets.model.Currency = window.Currency), jQuery("[data-cart-view]").each(function() {
                var t;
                return t = rivets.bind(jQuery(this), i.Rivets.model), i.Rivets.boundViews.push(t)
            })
        },
        unbindViews: function() {
            var t, e, o, s;
            for (s = i.Rivets.boundViews, e = 0, o = s.length; e < o; e++) t = s[e], t.unbind();
            return i.Rivets.boundViews = []
        }
    }, rivets.formatters.eq = function(t, e) {
        return t === e
    }, rivets.formatters.includes = function(t, e) {
        return t.indexOf(e) >= 0
    }, rivets.formatters.match = function(t, e, i) {
        return t.match(new RegExp(e, i))
    }, rivets.formatters.lt = function(t, e) {
        return t < e
    }, rivets.formatters.gt = function(t, e) {
        return t > e
    }, rivets.formatters.not = function(t) {
        return !t
    }, rivets.formatters.empty = function(t) {
        return !t.length
    }, rivets.formatters.plus = function(t, e) {
        return parseInt(t) + parseInt(e)
    }, rivets.formatters.minus = function(t, e) {
        return parseInt(t) - parseInt(e)
    }, rivets.formatters.prepend = function(t, e) {
        return e + t
    }, rivets.formatters.append = function(t, e) {
        return t + e
    }, rivets.formatters.slice = function(t, e, i) {
        return t.slice(e, i)
    }, rivets.formatters.pluralize = function(t, e, o) {
        return null == o && (o = e + "s"), i.Utils.isArray(t) && (t = t.length), 1 === t ? e : o
    }, rivets.formatters.array_element = function(t, e) {
        return t[e]
    }, rivets.formatters.array_first = function(t) {
        return t[0]
    }, rivets.formatters.array_last = function(t) {
        return t[t.length - 1]
    }, rivets.formatters.money = function(t, e) {
        return i.Utils.formatMoney(t, i.settings.moneyFormat, "money_format", e)
    }, rivets.formatters.money_with_currency = function(t, e) {
        return i.Utils.formatMoney(t, i.settings.moneyWithCurrencyFormat, "money_with_currency_format", e)
    }, rivets.formatters.weight = function(t) {
        switch (i.settings.weightUnit) {
            case "kg":
                return (t / 1e3).toFixed(i.settings.weightPrecision);
            case "oz":
                return (.035274 * t).toFixed(i.settings.weightPrecision);
            case "lb":
                return (.00220462 * t).toFixed(i.settings.weightPrecision);
            default:
                return t.toFixed(i.settings.weightPrecision)
        }
    }, rivets.formatters.weight_with_unit = function(t) {
        return rivets.formatters.weight(t) + i.settings.weightUnit
    }, rivets.formatters.product_image_size = function(t, e) {
        return i.Utils.getSizedImageUrl(t, e)
    }, rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency, rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit, rivets.formatters.productImageSize = rivets.formatters.product_image_size) : i.Rivets = {
        init: function() {},
        destroy: function() {}
    }, i.factory = function(t) {
        return t.init = i.init, t.configure = i.configure, t.cart = i.cart, t.settings = i.settings, t.getCart = i.Core.getCart, t.addItem = i.Core.addItem, t.updateItem = i.Core.updateItem, t.updateItemById = i.Core.updateItemById, t.updateItemQuantitiesById = i.Core.updateItemQuantitiesById, t.removeItem = i.Core.removeItem, t.removeItemById = i.Core.removeItemById, t.clear = i.Core.clear, t.getAttribute = i.Core.getAttribute, t.setAttribute = i.Core.setAttribute, t.getAttributes = i.Core.getAttributes, t.setAttributes = i.Core.setAttributes, t.clearAttributes = i.Core.clearAttributes, t.getNote = i.Core.getNote, t.setNote = i.Core.setNote, t.render = i.Data.render
    }, "object" == typeof exports ? i.factory(exports) : "function" == typeof define && define.amd ? define(["exports"], function(t) {
        return i.factory(this.CartJS = t), t
    }) : i.factory(this.CartJS = {})
}.call(this),
    function() {
        var t;
        t = function() {
                function t(t, e) {
                    var i, o;
                    if (this.options = {
                            target: "instafeed",
                            get: "popular",
                            resolution: "thumbnail",
                            sortBy: "none",
                            links: !0,
                            mock: !1,
                            useHttp: !1
                        }, "object" == typeof t)
                        for (i in t) o = t[i], this.options[i] = o;
                    this.context = null != e ? e : this, this.unique = this._genKey()
                }
                return t.prototype.hasNext = function() {
                    return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0
                }, t.prototype.next = function() {
                    return !!this.hasNext() && this.run(this.context.nextUrl)
                }, t.prototype.run = function(e) {
                    var i, o, s;
                    if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken) throw new Error("Missing clientId or accessToken.");
                    if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId) throw new Error("Missing clientId or accessToken.");
                    return null != this.options.before && "function" == typeof this.options.before && this.options.before.call(this), "undefined" != typeof document && null !== document && (s = document.createElement("script"), s.id = "instafeed-fetcher", s.src = e || this._buildUrl(), i = document.getElementsByTagName("head"), i[0].appendChild(s), o = "instafeedCache" + this.unique, window[o] = new t(this.options, this), window[o].unique = this.unique), !0
                }, t.prototype.parse = function(t) {
                    var e, i, o, s, n, r, a, l, d, c, p, u, h, f, v, y, m, g, w, k, S, C, T, b, $, x, A, I, j, P, O, E, z;
                    if ("object" != typeof t) {
                        if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "Invalid JSON data"), !1;
                        throw new Error("Invalid JSON response")
                    }
                    if (200 !== t.meta.code) {
                        if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, t.meta.error_message), !1;
                        throw new Error("Error from Instagram: " + t.meta.error_message)
                    }
                    if (0 === t.data.length) {
                        if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "No images were returned from Instagram"), !1;
                        throw new Error("No images were returned from Instagram")
                    }
                    if (null != this.options.success && "function" == typeof this.options.success && this.options.success.call(this, t), this.context.nextUrl = "", null != t.pagination && (this.context.nextUrl = t.pagination.next_url), "none" !== this.options.sortBy) switch (O = "random" === this.options.sortBy ? ["", "random"] : this.options.sortBy.split("-"), P = "least" === O[0], O[1]) {
                        case "random":
                            t.data.sort(function() {
                                return .5 - Math.random()
                            });
                            break;
                        case "recent":
                            t.data = this._sortBy(t.data, "created_time", P);
                            break;
                        case "liked":
                            t.data = this._sortBy(t.data, "likes.count", P);
                            break;
                        case "commented":
                            t.data = this._sortBy(t.data, "comments.count", P);
                            break;
                        default:
                            throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.")
                    }
                    if ("undefined" != typeof document && null !== document && this.options.mock === !1) {
                        if (y = t.data, j = parseInt(this.options.limit, 10), null != this.options.limit && y.length > j && (y = y.slice(0, j)), a = document.createDocumentFragment(), null != this.options.filter && "function" == typeof this.options.filter && (y = this._filter(y, this.options.filter)), null != this.options.template && "string" == typeof this.options.template) {
                            for (d = "", f = "", k = "", z = document.createElement("div"), p = 0, $ = y.length; p < $; p++) {
                                if (u = y[p], h = u.images[this.options.resolution], "object" != typeof h) throw r = "No image found for resolution: " + this.options.resolution + ".", new Error(r);
                                S = h.width, g = h.height, w = "square", S > g && (w = "landscape"), S < g && (w = "portrait"), v = h.url, c = window.location.protocol.indexOf("http") >= 0, c && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")), f = this._makeTemplate(this.options.template, {
                                    model: u,
                                    id: u.id,
                                    link: u.link,
                                    type: u.type,
                                    image: v,
                                    width: S,
                                    height: g,
                                    orientation: w,
                                    caption: this._getObjectProperty(u, "caption.text"),
                                    likes: u.likes.count,
                                    comments: u.comments.count,
                                    location: this._getObjectProperty(u, "location.name")
                                }), d += f
                            }
                            for (z.innerHTML = d, s = [], o = 0, i = z.childNodes.length; o < i;) s.push(z.childNodes[o]), o += 1;
                            for (T = 0, x = s.length; T < x; T++) I = s[T], a.appendChild(I)
                        } else
                            for (b = 0, A = y.length; b < A; b++) {
                                if (u = y[b], m = document.createElement("img"), h = u.images[this.options.resolution], "object" != typeof h) throw r = "No image found for resolution: " + this.options.resolution + ".", new Error(r);
                                v = h.url, c = window.location.protocol.indexOf("http") >= 0, c && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")), m.src = v, this.options.links === !0 ? (e = document.createElement("a"), e.href = u.link, e.appendChild(m), a.appendChild(e)) : a.appendChild(m)
                            }
                        if (E = this.options.target, "string" == typeof E && (E = document.getElementById(E)), null == E) throw r = 'No element with id="' + this.options.target + '" on page.', new Error(r);
                        E.appendChild(a), l = document.getElementsByTagName("head")[0], l.removeChild(document.getElementById("instafeed-fetcher")), C = "instafeedCache" + this.unique, window[C] = void 0;
                        try {
                            delete window[C]
                        } catch (M) {
                            n = M
                        }
                    }
                    return null != this.options.after && "function" == typeof this.options.after && this.options.after.call(this), !0
                }, t.prototype._buildUrl = function() {
                    var t, e, i;
                    switch (t = "https://api.instagram.com/v1", this.options.get) {
                        case "popular":
                            e = "media/popular";
                            break;
                        case "tagged":
                            if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                            e = "tags/" + this.options.tagName + "/media/recent";
                            break;
                        case "location":
                            if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                            e = "locations/" + this.options.locationId + "/media/recent";
                            break;
                        case "user":
                            if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                            e = "users/" + this.options.userId + "/media/recent";
                            break;
                        default:
                            throw new Error("Invalid option for get: '" + this.options.get + "'.")
                    }
                    return i = t + "/" + e, i += null != this.options.accessToken ? "?access_token=" + this.options.accessToken : "?client_id=" + this.options.clientId, null != this.options.limit && (i += "&count=" + this.options.limit), i += "&callback=instafeedCache" + this.unique + ".parse"
                }, t.prototype._genKey = function() {
                    var t;
                    return t = function() {
                        return (65536 * (1 + Math.random()) | 0).toString(16).substring(1)
                    }, "" + t() + t() + t() + t()
                }, t.prototype._makeTemplate = function(t, e) {
                    var i, o, s, n, r;
                    for (o = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, i = t; o.test(i);) n = i.match(o)[1], r = null != (s = this._getObjectProperty(e, n)) ? s : "", i = i.replace(o, function() {
                        return "" + r
                    });
                    return i
                }, t.prototype._getObjectProperty = function(t, e) {
                    var i, o;
                    for (e = e.replace(/\[(\w+)\]/g, ".$1"), o = e.split("."); o.length;) {
                        if (i = o.shift(), !(null != t && i in t)) return null;
                        t = t[i]
                    }
                    return t
                }, t.prototype._sortBy = function(t, e, i) {
                    var o;
                    return o = function(t, o) {
                        var s, n;
                        return s = this._getObjectProperty(t, e), n = this._getObjectProperty(o, e), i ? s > n ? 1 : -1 : s < n ? 1 : -1
                    }, t.sort(o.bind(this)), t
                }, t.prototype._filter = function(t, e) {
                    var i, o, s, n, r;
                    for (i = [], o = function(t) {
                            if (e(t)) return i.push(t)
                        }, s = 0, r = t.length; s < r; s++) n = t[s], o(n);
                    return i
                }, t
            }(),
            function(t, e) {
                return "function" == typeof define && define.amd ? define([], e) : "object" == typeof module && module.exports ? module.exports = e() : t.Instafeed = e()
            }(this, function() {
                return t
            })
    }.call(this),
    function(t) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
    }(function(t) {
        "use strict";
        var e = window.Slick || {};
        e = function() {
            function e(e, o) {
                var s, n = this;
                n.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: t(e),
                    appendDots: t(e),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function(e, i) {
                        return t('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1)
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: .35,
                    fade: !1,
                    focusOnSelect: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3
                }, n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1
                }, t.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = t(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = t(e).data("slick") || {}, n.options = t.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, "undefined" != typeof document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = t.proxy(n.autoPlay, n), n.autoPlayClear = t.proxy(n.autoPlayClear, n), n.autoPlayIterator = t.proxy(n.autoPlayIterator, n), n.changeSlide = t.proxy(n.changeSlide, n), n.clickHandler = t.proxy(n.clickHandler, n), n.selectHandler = t.proxy(n.selectHandler, n), n.setPosition = t.proxy(n.setPosition, n), n.swipeHandler = t.proxy(n.swipeHandler, n), n.dragHandler = t.proxy(n.dragHandler, n), n.keyHandler = t.proxy(n.keyHandler, n), n.instanceUid = i++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
            }
            var i = 0;
            return e
        }(), e.prototype.activateADA = function() {
            var t = this;
            t.$slideTrack.find(".slick-active").attr({
                "aria-hidden": "false"
            }).find("a, input, button, select").attr({
                tabindex: "0"
            })
        }, e.prototype.addSlide = e.prototype.slickAdd = function(e, i, o) {
            var s = this;
            if ("boolean" == typeof i) o = i, i = null;
            else if (i < 0 || i >= s.slideCount) return !1;
            s.unload(), "number" == typeof i ? 0 === i && 0 === s.$slides.length ? t(e).appendTo(s.$slideTrack) : o ? t(e).insertBefore(s.$slides.eq(i)) : t(e).insertAfter(s.$slides.eq(i)) : o === !0 ? t(e).prependTo(s.$slideTrack) : t(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function(e, i) {
                t(i).attr("data-slick-index", e)
            }), s.$slidesCache = s.$slides, s.reinit()
        }, e.prototype.animateHeight = function() {
            var t = this;
            if (1 === t.options.slidesToShow && t.options.adaptiveHeight === !0 && t.options.vertical === !1) {
                var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                t.$list.animate({
                    height: e
                }, t.options.speed)
            }
        }, e.prototype.animateSlide = function(e, i) {
            var o = {},
                s = this;
            s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
                left: e
            }, s.options.speed, s.options.easing, i) : s.$slideTrack.animate({
                top: e
            }, s.options.speed, s.options.easing, i) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), t({
                animStart: s.currentLeft
            }).animate({
                animStart: e
            }, {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function(t) {
                    t = Math.ceil(t), s.options.vertical === !1 ? (o[s.animType] = "translate(" + t + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + t + "px)", s.$slideTrack.css(o))
                },
                complete: function() {
                    i && i.call()
                }
            })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), i && setTimeout(function() {
                s.disableTransition(), i.call()
            }, s.options.speed))
        }, e.prototype.getNavTarget = function() {
            var e = this,
                i = e.options.asNavFor;
            return i && null !== i && (i = t(i).not(e.$slider)), i
        }, e.prototype.asNavFor = function(e) {
            var i = this,
                o = i.getNavTarget();
            null !== o && "object" == typeof o && o.each(function() {
                var i = t(this).slick("getSlick");
                i.unslicked || i.slideHandler(e, !0)
            })
        }, e.prototype.applyTransition = function(t) {
            var e = this,
                i = {};
            e.options.fade === !1 ? i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
        }, e.prototype.autoPlay = function() {
            var t = this;
            t.autoPlayClear(), t.slideCount > t.options.slidesToShow && (t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed))
        }, e.prototype.autoPlayClear = function() {
            var t = this;
            t.autoPlayTimer && clearInterval(t.autoPlayTimer)
        }, e.prototype.autoPlayIterator = function() {
            var t = this,
                e = t.currentSlide + t.options.slidesToScroll;
            t.paused || t.interrupted || t.focussed || (t.options.infinite === !1 && (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1 ? t.direction = 0 : 0 === t.direction && (e = t.currentSlide - t.options.slidesToScroll, t.currentSlide - 1 === 0 && (t.direction = 1))), t.slideHandler(e))
        }, e.prototype.buildArrows = function() {
            var e = this;
            e.options.arrows === !0 && (e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                "aria-disabled": "true",
                tabindex: "-1"
            }))
        }, e.prototype.buildDots = function() {
            var e, i, o = this;
            if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
                for (o.$slider.addClass("slick-dotted"), i = t("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) i.append(t("<li />").append(o.options.customPaging.call(this, o, e)));
                o.$dots = i.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
            }
        }, e.prototype.buildOut = function() {
            var e = this;
            e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, i) {
                t(i).attr("data-slick-index", e).data("originalStyling", t(i).attr("style") || "")
            }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? t('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass("draggable")
        }, e.prototype.buildRows = function() {
            var t, e, i, o, s, n, r, a = this;
            if (o = document.createDocumentFragment(), n = a.$slider.children(), a.options.rows > 1) {
                for (r = a.options.slidesPerRow * a.options.rows, s = Math.ceil(n.length / r), t = 0; t < s; t++) {
                    var l = document.createElement("div");
                    for (e = 0; e < a.options.rows; e++) {
                        var d = document.createElement("div");
                        for (i = 0; i < a.options.slidesPerRow; i++) {
                            var c = t * r + (e * a.options.slidesPerRow + i);
                            n.get(c) && d.appendChild(n.get(c))
                        }
                        l.appendChild(d)
                    }
                    o.appendChild(l)
                }
                a.$slider.empty().append(o), a.$slider.children().children().children().css({
                    width: 100 / a.options.slidesPerRow + "%",
                    display: "inline-block"
                })
            }
        }, e.prototype.checkResponsive = function(e, i) {
            var o, s, n, r = this,
                a = !1,
                l = r.$slider.width(),
                d = window.innerWidth || t(window).width();
            if ("window" === r.respondTo ? n = d : "slider" === r.respondTo ? n = l : "min" === r.respondTo && (n = Math.min(d, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
                s = null;
                for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
                null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || i) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = t.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), a = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), a = s), e || a === !1 || r.$slider.trigger("breakpoint", [r, a])
            }
        }, e.prototype.changeSlide = function(e, i) {
            var o, s, n, r = this,
                a = t(e.currentTarget);
            switch (a.is("a") && e.preventDefault(), a.is("li") || (a = a.closest("li")), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
                case "previous":
                    s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, i);
                    break;
                case "next":
                    s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, i);
                    break;
                case "index":
                    var l = 0 === e.data.index ? 0 : e.data.index || a.index() * r.options.slidesToScroll;
                    r.slideHandler(r.checkNavigable(l), !1, i), a.children().trigger("focus");
                    break;
                default:
                    return
            }
        }, e.prototype.checkNavigable = function(t) {
            var e, i, o = this;
            if (e = o.getNavigableIndexes(), i = 0, t > e[e.length - 1]) t = e[e.length - 1];
            else
                for (var s in e) {
                    if (t < e[s]) {
                        t = i;
                        break
                    }
                    i = e[s]
                }
            return t
        }, e.prototype.cleanUpEvents = function() {
            var e = this;
            e.options.dots && null !== e.$dots && t("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", t.proxy(e.interrupt, e, !0)).off("mouseleave.slick", t.proxy(e.interrupt, e, !1)), e.$slider.off("focus.slick blur.slick"), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                e.$list.off("click.slick", e.clickHandler), t(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && t(e.$slideTrack).children().off("click.slick", e.selectHandler), t(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), t(window).off("resize.slick.slick-" + e.instanceUid, e.resize), t("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
        }, e.prototype.cleanUpSlideEvents = function() {
            var e = this;
            e.$list.off("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", t.proxy(e.interrupt, e, !1))
        }, e.prototype.cleanUpRows = function() {
            var t, e = this;
            e.options.rows > 1 && (t = e.$slides.children().children(), t.removeAttr("style"), e.$slider.empty().append(t))
        }, e.prototype.clickHandler = function(t) {
            var e = this;
            e.shouldClick === !1 && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault())
        }, e.prototype.destroy = function(e) {
            var i = this;
            i.autoPlayClear(), i.touchObject = {}, i.cleanUpEvents(), t(".slick-cloned", i.$slider).detach(), i.$dots && i.$dots.remove(), i.$prevArrow && i.$prevArrow.length && (i.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()), i.$nextArrow && i.$nextArrow.length && (i.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()), i.$slides && (i.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                t(this).attr("style", t(this).data("originalStyling"))
            }), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.detach(), i.$list.detach(), i.$slider.append(i.$slides)), i.cleanUpRows(), i.$slider.removeClass("slick-slider"), i.$slider.removeClass("slick-initialized"), i.$slider.removeClass("slick-dotted"), i.unslicked = !0, e || i.$slider.trigger("destroy", [i])
        }, e.prototype.disableTransition = function(t) {
            var e = this,
                i = {};
            i[e.transitionType] = "", e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i)
        }, e.prototype.fadeSlide = function(t, e) {
            var i = this;
            i.cssTransitions === !1 ? (i.$slides.eq(t).css({
                zIndex: i.options.zIndex
            }), i.$slides.eq(t).animate({
                opacity: 1
            }, i.options.speed, i.options.easing, e)) : (i.applyTransition(t), i.$slides.eq(t).css({
                opacity: 1,
                zIndex: i.options.zIndex
            }), e && setTimeout(function() {
                i.disableTransition(t), e.call()
            }, i.options.speed))
        }, e.prototype.fadeSlideOut = function(t) {
            var e = this;
            e.cssTransitions === !1 ? e.$slides.eq(t).animate({
                opacity: 0,
                zIndex: e.options.zIndex - 2
            }, e.options.speed, e.options.easing) : (e.applyTransition(t), e.$slides.eq(t).css({
                opacity: 0,
                zIndex: e.options.zIndex - 2
            }))
        }, e.prototype.filterSlides = e.prototype.slickFilter = function(t) {
            var e = this;
            null !== t && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(t).appendTo(e.$slideTrack), e.reinit())
        }, e.prototype.focusHandler = function() {
            var e = this;
            e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(i) {
                i.stopImmediatePropagation();
                var o = t(this);
                setTimeout(function() {
                    e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay())
                }, 0)
            })
        }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
            var t = this;
            return t.currentSlide
        }, e.prototype.getDotCount = function() {
            var t = this,
                e = 0,
                i = 0,
                o = 0;
            if (t.options.infinite === !0)
                for (; e < t.slideCount;) ++o, e = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
            else if (t.options.centerMode === !0) o = t.slideCount;
            else if (t.options.asNavFor)
                for (; e < t.slideCount;) ++o, e = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
            else o = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll);
            return o - 1
        }, e.prototype.getLeft = function(t) {
            var e, i, o, s = this,
                n = 0;
            return s.slideOffset = 0, i = s.$slides.first().outerHeight(!0), s.options.infinite === !0 ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = s.slideWidth * s.options.slidesToShow * -1, n = i * s.options.slidesToShow * -1), s.slideCount % s.options.slidesToScroll !== 0 && t + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (t > s.slideCount ? (s.slideOffset = (s.options.slidesToShow - (t - s.slideCount)) * s.slideWidth * -1, n = (s.options.slidesToShow - (t - s.slideCount)) * i * -1) : (s.slideOffset = s.slideCount % s.options.slidesToScroll * s.slideWidth * -1, n = s.slideCount % s.options.slidesToScroll * i * -1))) : t + s.options.slidesToShow > s.slideCount && (s.slideOffset = (t + s.options.slidesToShow - s.slideCount) * s.slideWidth, n = (t + s.options.slidesToShow - s.slideCount) * i), s.slideCount <= s.options.slidesToShow && (s.slideOffset = 0, n = 0), s.options.centerMode === !0 && s.slideCount <= s.options.slidesToShow ? s.slideOffset = s.slideWidth * Math.floor(s.options.slidesToShow) / 2 - s.slideWidth * s.slideCount / 2 : s.options.centerMode === !0 && s.options.infinite === !0 ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : s.options.centerMode === !0 && (s.slideOffset = 0, s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)), e = s.options.vertical === !1 ? t * s.slideWidth * -1 + s.slideOffset : t * i * -1 + n, s.options.variableWidth === !0 && (o = s.slideCount <= s.options.slidesToShow || s.options.infinite === !1 ? s.$slideTrack.children(".slick-slide").eq(t) : s.$slideTrack.children(".slick-slide").eq(t + s.options.slidesToShow), e = s.options.rtl === !0 ? o[0] ? (s.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, s.options.centerMode === !0 && (o = s.slideCount <= s.options.slidesToShow || s.options.infinite === !1 ? s.$slideTrack.children(".slick-slide").eq(t) : s.$slideTrack.children(".slick-slide").eq(t + s.options.slidesToShow + 1), e = s.options.rtl === !0 ? o[0] ? (s.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (s.$list.width() - o.outerWidth()) / 2)), e
        }, e.prototype.getOption = e.prototype.slickGetOption = function(t) {
            var e = this;
            return e.options[t]
        }, e.prototype.getNavigableIndexes = function() {
            var t, e = this,
                i = 0,
                o = 0,
                s = [];
            for (e.options.infinite === !1 ? t = e.slideCount : (i = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, t = 2 * e.slideCount); i < t;) s.push(i), i = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            return s
        }, e.prototype.getSlick = function() {
            return this
        }, e.prototype.getSlideCount = function() {
            var e, i, o, s = this;
            return o = s.options.centerMode === !0 ? s.slideWidth * Math.floor(s.options.slidesToShow / 2) : 0, s.options.swipeToSlide === !0 ? (s.$slideTrack.find(".slick-slide").each(function(e, n) {
                if (n.offsetLeft - o + t(n).outerWidth() / 2 > s.swipeLeft * -1) return i = n, !1
            }), e = Math.abs(t(i).attr("data-slick-index") - s.currentSlide) || 1) : s.options.slidesToScroll
        }, e.prototype.goTo = e.prototype.slickGoTo = function(t, e) {
            var i = this;
            i.changeSlide({
                data: {
                    message: "index",
                    index: parseInt(t)
                }
            }, e)
        }, e.prototype.init = function(e) {
            var i = this;
            t(i.$slider).hasClass("slick-initialized") || (t(i.$slider).addClass("slick-initialized"), i.buildRows(), i.buildOut(), i.setProps(), i.startLoad(), i.loadSlider(), i.initializeEvents(), i.updateArrows(), i.updateDots(), i.checkResponsive(!0), i.focusHandler()), e && i.$slider.trigger("init", [i]), i.options.accessibility === !0 && i.initADA(), i.options.autoplay && (i.paused = !1, i.autoPlay())
        }, e.prototype.initADA = function() {
            var e = this;
            e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
                "aria-hidden": "true",
                tabindex: "-1"
            }).find("a, input, button, select").attr({
                tabindex: "-1"
            }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(i) {
                t(this).attr("role", "option");
                var o = e.options.centerMode ? i : Math.floor(i / e.options.slidesToShow);
                e.options.dots === !0 && t(this).attr("aria-describedby", "slick-slide" + e.instanceUid + o)
            }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(i) {
                t(this).attr({
                    role: "presentation",
                    "aria-selected": "false",
                    "aria-controls": "navigation" + e.instanceUid + i,
                    id: "slick-slide" + e.instanceUid + i
                })
            }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), e.activateADA()
        }, e.prototype.initArrowEvents = function() {
            var t = this;
            t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.off("click.slick").on("click.slick", {
                message: "previous"
            }, t.changeSlide), t.$nextArrow.off("click.slick").on("click.slick", {
                message: "next"
            }, t.changeSlide))
        }, e.prototype.initDotEvents = function() {
            var e = this;
            e.options.dots === !0 && e.slideCount > e.options.slidesToShow && t("li", e.$dots).on("click.slick", {
                message: "index"
            }, e.changeSlide), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && t("li", e.$dots).on("mouseenter.slick", t.proxy(e.interrupt, e, !0)).on("mouseleave.slick", t.proxy(e.interrupt, e, !1))
        }, e.prototype.initSlideEvents = function() {
            var e = this;
            e.options.pauseOnHover && (e.$list.on("mouseenter.slick", t.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", t.proxy(e.interrupt, e, !1)))
        }, e.prototype.initializeEvents = function() {
            var e = this;
            e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
                action: "start"
            }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
                action: "move"
            }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
                action: "end"
            }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
                action: "end"
            }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), t(document).on(e.visibilityChange, t.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler), e.options.focusOnSelect === !0 && t(e.$slideTrack).children().on("click.slick", e.selectHandler), t(window).on("orientationchange.slick.slick-" + e.instanceUid, t.proxy(e.orientationChange, e)), t(window).on("resize.slick.slick-" + e.instanceUid, t.proxy(e.resize, e)), t("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), t(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
        }, e.prototype.initUI = function() {
            var t = this;
            t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.show(), t.$nextArrow.show()), t.options.dots === !0 && t.slideCount > t.options.slidesToShow && t.$dots.show()
        }, e.prototype.keyHandler = function(t) {
            var e = this;
            t.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === t.keyCode && e.options.accessibility === !0 ? e.changeSlide({
                data: {
                    message: e.options.rtl === !0 ? "next" : "previous"
                }
            }) : 39 === t.keyCode && e.options.accessibility === !0 && e.changeSlide({
                data: {
                    message: e.options.rtl === !0 ? "previous" : "next"
                }
            }))
        }, e.prototype.lazyLoad = function() {
            function e(e) {
                t("img[data-lazy]", e).each(function() {
                    var e = t(this),
                        i = t(this).attr("data-lazy"),
                        o = document.createElement("img");
                    o.onload = function() {
                        e.animate({
                            opacity: 0
                        }, 100, function() {
                            e.attr("src", i).animate({
                                opacity: 1
                            }, 200, function() {
                                e.removeAttr("data-lazy").removeClass("slick-loading")
                            }), r.$slider.trigger("lazyLoaded", [r, e, i])
                        })
                    }, o.onerror = function() {
                        e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, e, i])
                    }, o.src = i
                })
            }
            var i, o, s, n, r = this;
            if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), i = r.$slider.find(".slick-slide").slice(s, n), "anticipated" === r.options.lazyLoad)
                for (var a = s - 1, l = n, d = r.$slider.find(".slick-slide"), c = 0; c < r.options.slidesToScroll; c++) a < 0 && (a = r.slideCount - 1), i = i.add(d.eq(a)), i = i.add(d.eq(l)), a--, l++;
            e(i), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find(".slick-slide"), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find(".slick-cloned").slice(r.options.slidesToShow * -1), e(o))
        }, e.prototype.loadSlider = function() {
            var t = this;
            t.setPosition(), t.$slideTrack.css({
                opacity: 1
            }), t.$slider.removeClass("slick-loading"), t.initUI(), "progressive" === t.options.lazyLoad && t.progressiveLazyLoad()
        }, e.prototype.next = e.prototype.slickNext = function() {
            var t = this;
            t.changeSlide({
                data: {
                    message: "next"
                }
            })
        }, e.prototype.orientationChange = function() {
            var t = this;
            t.checkResponsive(), t.setPosition()
        }, e.prototype.pause = e.prototype.slickPause = function() {
            var t = this;
            t.autoPlayClear(), t.paused = !0
        }, e.prototype.play = e.prototype.slickPlay = function() {
            var t = this;
            t.autoPlay(), t.options.autoplay = !0, t.paused = !1, t.focussed = !1, t.interrupted = !1
        }, e.prototype.postSlide = function(t) {
            var e = this;
            e.unslicked || (e.$slider.trigger("afterChange", [e, t]), e.animating = !1, e.setPosition(), e.swipeLeft = null, e.options.autoplay && e.autoPlay(), e.options.accessibility === !0 && e.initADA())
        }, e.prototype.prev = e.prototype.slickPrev = function() {
            var t = this;
            t.changeSlide({
                data: {
                    message: "previous"
                }
            })
        }, e.prototype.preventDefault = function(t) {
            t.preventDefault()
        }, e.prototype.progressiveLazyLoad = function(e) {
            e = e || 1;
            var i, o, s, n = this,
                r = t("img[data-lazy]", n.$slider);
            r.length ? (i = r.first(), o = i.attr("data-lazy"), s = document.createElement("img"), s.onload = function() {
                i.attr("src", o).removeAttr("data-lazy").removeClass("slick-loading"), n.options.adaptiveHeight === !0 && n.setPosition(), n.$slider.trigger("lazyLoaded", [n, i, o]), n.progressiveLazyLoad()
            }, s.onerror = function() {
                e < 3 ? setTimeout(function() {
                    n.progressiveLazyLoad(e + 1)
                }, 500) : (i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, i, o]), n.progressiveLazyLoad())
            }, s.src = o) : n.$slider.trigger("allImagesLoaded", [n])
        }, e.prototype.refresh = function(e) {
            var i, o, s = this;
            o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), i = s.currentSlide, s.destroy(!0), t.extend(s, s.initials, {
                currentSlide: i
            }), s.init(), e || s.changeSlide({
                data: {
                    message: "index",
                    index: i
                }
            }, !1)
        }, e.prototype.registerBreakpoints = function() {
            var e, i, o, s = this,
                n = s.options.responsive || null;
            if ("array" === t.type(n) && n.length) {
                s.respondTo = s.options.respondTo || "window";
                for (e in n)
                    if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
                        for (i = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === i && s.breakpoints.splice(o, 1), o--;
                        s.breakpoints.push(i), s.breakpointSettings[i] = n[e].settings
                    } s.breakpoints.sort(function(t, e) {
                    return s.options.mobileFirst ? t - e : e - t
                })
            }
        }, e.prototype.reinit = function() {
            var e = this;
            e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && t(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
        }, e.prototype.resize = function() {
            var e = this;
            t(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
                e.windowWidth = t(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
            }, 50))
        }, e.prototype.removeSlide = e.prototype.slickRemove = function(t, e, i) {
            var o = this;
            return "boolean" == typeof t ? (e = t, t = e === !0 ? 0 : o.slideCount - 1) : t = e === !0 ? --t : t, !(o.slideCount < 1 || t < 0 || t > o.slideCount - 1) && (o.unload(), i === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(t).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit())
        }, e.prototype.setCSS = function(t) {
            var e, i, o = this,
                s = {};
            o.options.rtl === !0 && (t = -t), e = "left" == o.positionProp ? Math.ceil(t) + "px" : "0px", i = "top" == o.positionProp ? Math.ceil(t) + "px" : "0px", s[o.positionProp] = t, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = "translate(" + e + ", " + i + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + i + ", 0px)", o.$slideTrack.css(s)))
        }, e.prototype.setDimensions = function() {
            var t = this;
            t.options.vertical === !1 ? t.options.centerMode === !0 && t.$list.css({
                padding: "0px " + t.options.centerPadding
            }) : (t.$list.height(t.$slides.first().outerHeight(!0) * t.options.slidesToShow), t.options.centerMode === !0 && t.$list.css({
                padding: t.options.centerPadding + " 0px"
            })), t.listWidth = t.$list.width(), t.listHeight = t.$list.height(), t.options.vertical === !1 && t.options.variableWidth === !1 ? (t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))) : t.options.variableWidth === !0 ? t.$slideTrack.width(5e3 * t.slideCount) : (t.slideWidth = Math.ceil(t.listWidth), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
            var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
            t.options.variableWidth === !1 && t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
        }, e.prototype.setFade = function() {
            var e, i = this;
            i.$slides.each(function(o, s) {
                e = i.slideWidth * o * -1, i.options.rtl === !0 ? t(s).css({
                    position: "relative",
                    right: e,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0
                }) : t(s).css({
                    position: "relative",
                    left: e,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0
                })
            }), i.$slides.eq(i.currentSlide).css({
                zIndex: i.options.zIndex - 1,
                opacity: 1
            })
        }, e.prototype.setHeight = function() {
            var t = this;
            if (1 === t.options.slidesToShow && t.options.adaptiveHeight === !0 && t.options.vertical === !1) {
                var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                t.$list.css("height", e)
            }
        }, e.prototype.setOption = e.prototype.slickSetOption = function() {
            var e, i, o, s, n, r = this,
                a = !1;
            if ("object" === t.type(arguments[0]) ? (o = arguments[0], a = arguments[1], n = "multiple") : "string" === t.type(arguments[0]) && (o = arguments[0], s = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === t.type(arguments[1]) ? n = "responsive" : "undefined" != typeof arguments[1] && (n = "single")), "single" === n) r.options[o] = s;
            else if ("multiple" === n) t.each(o, function(t, e) {
                r.options[t] = e
            });
            else if ("responsive" === n)
                for (i in s)
                    if ("array" !== t.type(r.options.responsive)) r.options.responsive = [s[i]];
                    else {
                        for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[i].breakpoint && r.options.responsive.splice(e, 1), e--;
                        r.options.responsive.push(s[i])
                    } a && (r.unload(), r.reinit())
        }, e.prototype.setPosition = function() {
            var t = this;
            t.setDimensions(), t.setHeight(), t.options.fade === !1 ? t.setCSS(t.getLeft(t.currentSlide)) : t.setFade(), t.$slider.trigger("setPosition", [t])
        }, e.prototype.setProps = function() {
            var t = this,
                e = document.body.style;
            t.positionProp = t.options.vertical === !0 ? "top" : "left", "top" === t.positionProp ? t.$slider.addClass("slick-vertical") : t.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || t.options.useCSS === !0 && (t.cssTransitions = !0), t.options.fade && ("number" == typeof t.options.zIndex ? t.options.zIndex < 3 && (t.options.zIndex = 3) : t.options.zIndex = t.defaults.zIndex), void 0 !== e.OTransform && (t.animType = "OTransform", t.transformType = "-o-transform", t.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.MozTransform && (t.animType = "MozTransform", t.transformType = "-moz-transform", t.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (t.animType = !1)), void 0 !== e.webkitTransform && (t.animType = "webkitTransform", t.transformType = "-webkit-transform", t.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (t.animType = !1)), void 0 !== e.msTransform && (t.animType = "msTransform", t.transformType = "-ms-transform", t.transitionType = "msTransition", void 0 === e.msTransform && (t.animType = !1)), void 0 !== e.transform && t.animType !== !1 && (t.animType = "transform", t.transformType = "transform", t.transitionType = "transition"), t.transformsEnabled = t.options.useTransform && null !== t.animType && t.animType !== !1
        }, e.prototype.setSlideClasses = function(t) {
            var e, i, o, s, n = this;
            i = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(t).addClass("slick-current"), n.options.centerMode === !0 ? (e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (t >= e && t <= n.slideCount - 1 - e ? n.$slides.slice(t - e, t + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + t, i.slice(o - e + 1, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === t ? i.eq(i.length - 1 - n.options.slidesToShow).addClass("slick-center") : t === n.slideCount - 1 && i.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(t).addClass("slick-center")) : t >= 0 && t <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(t, t + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= n.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + t : t, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - t < n.options.slidesToShow ? i.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : i.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
        }, e.prototype.setupInfinite = function() {
            var e, i, o, s = this;
            if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (i = null, s.slideCount > s.options.slidesToShow)) {
                for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) i = e - 1, t(s.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
                for (e = 0; e < o; e += 1) i = e, t(s.$slides[i]).clone(!0).attr("id", "").attr("data-slick-index", i + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
                s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                    t(this).attr("id", "")
                })
            }
        }, e.prototype.interrupt = function(t) {
            var e = this;
            t || e.autoPlay(), e.interrupted = t
        }, e.prototype.selectHandler = function(e) {
            var i = this,
                o = t(e.target).is(".slick-slide") ? t(e.target) : t(e.target).parents(".slick-slide"),
                s = parseInt(o.attr("data-slick-index"));
            return s || (s = 0), i.slideCount <= i.options.slidesToShow ? (i.setSlideClasses(s), void i.asNavFor(s)) : void i.slideHandler(s)
        }, e.prototype.slideHandler = function(t, e, i) {
            var o, s, n, r, a, l = null,
                d = this;
            if (e = e || !1, (d.animating !== !0 || d.options.waitForAnimate !== !0) && !(d.options.fade === !0 && d.currentSlide === t || d.slideCount <= d.options.slidesToShow)) return e === !1 && d.asNavFor(t), o = t, l = d.getLeft(o), r = d.getLeft(d.currentSlide), d.currentLeft = null === d.swipeLeft ? r : d.swipeLeft, d.options.infinite === !1 && d.options.centerMode === !1 && (t < 0 || t > d.getDotCount() * d.options.slidesToScroll) ? void(d.options.fade === !1 && (o = d.currentSlide, i !== !0 ? d.animateSlide(r, function() {
                d.postSlide(o)
            }) : d.postSlide(o))) : d.options.infinite === !1 && d.options.centerMode === !0 && (t < 0 || t > d.slideCount - d.options.slidesToScroll) ? void(d.options.fade === !1 && (o = d.currentSlide, i !== !0 ? d.animateSlide(r, function() {
                d.postSlide(o)
            }) : d.postSlide(o))) : (d.options.autoplay && clearInterval(d.autoPlayTimer), s = o < 0 ? d.slideCount % d.options.slidesToScroll !== 0 ? d.slideCount - d.slideCount % d.options.slidesToScroll : d.slideCount + o : o >= d.slideCount ? d.slideCount % d.options.slidesToScroll !== 0 ? 0 : o - d.slideCount : o, d.animating = !0, d.$slider.trigger("beforeChange", [d, d.currentSlide, s]), n = d.currentSlide, d.currentSlide = s, d.setSlideClasses(d.currentSlide), d.options.asNavFor && (a = d.getNavTarget(), a = a.slick("getSlick"), a.slideCount <= a.options.slidesToShow && a.setSlideClasses(d.currentSlide)), d.updateDots(), d.updateArrows(), d.options.fade === !0 ? (i !== !0 ? (d.fadeSlideOut(n), d.fadeSlide(s, function() {
                d.postSlide(s)
            })) : d.postSlide(s), void d.animateHeight()) : void(i !== !0 ? d.animateSlide(l, function() {
                d.postSlide(s)
            }) : d.postSlide(s)))
        }, e.prototype.startLoad = function() {
            var t = this;
            t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow.hide(), t.$nextArrow.hide()), t.options.dots === !0 && t.slideCount > t.options.slidesToShow && t.$dots.hide(), t.$slider.addClass("slick-loading")
        }, e.prototype.swipeDirection = function() {
            var t, e, i, o, s = this;
            return t = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, i = Math.atan2(e, t), o = Math.round(180 * i / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? "left" : "right" : o <= 360 && o >= 315 ? s.options.rtl === !1 ? "left" : "right" : o >= 135 && o <= 225 ? s.options.rtl === !1 ? "right" : "left" : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
        }, e.prototype.swipeEnd = function(t) {
            var e, i, o = this;
            if (o.dragging = !1, o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
            if (o.touchObject.edgeHit === !0 && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
                switch (i = o.swipeDirection()) {
                    case "left":
                    case "down":
                        e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                        break;
                    case "right":
                    case "up":
                        e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
                }
                "vertical" != i && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, i]))
            } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
        }, e.prototype.swipeHandler = function(t) {
            var e = this;
            if (!(e.options.swipe === !1 || "ontouchend" in document && e.options.swipe === !1 || e.options.draggable === !1 && t.type.indexOf("mouse") !== -1)) switch (e.touchObject.fingerCount = t.originalEvent && void 0 !== t.originalEvent.touches ? t.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), t.data.action) {
                case "start":
                    e.swipeStart(t);
                    break;
                case "move":
                    e.swipeMove(t);
                    break;
                case "end":
                    e.swipeEnd(t)
            }
        }, e.prototype.swipeMove = function(t) {
            var e, i, o, s, n, r = this;
            return n = void 0 !== t.originalEvent ? t.originalEvent.touches : null, !(!r.dragging || n && 1 !== n.length) && (e = r.getLeft(r.currentSlide), r.touchObject.curX = void 0 !== n ? n[0].pageX : t.clientX, r.touchObject.curY = void 0 !== n ? n[0].pageY : t.clientY, r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), r.options.verticalSwiping === !0 && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))), i = r.swipeDirection(), "vertical" !== i ? (void 0 !== t.originalEvent && r.touchObject.swipeLength > 4 && t.preventDefault(), s = (r.options.rtl === !1 ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), r.options.verticalSwiping === !0 && (s = r.touchObject.curY > r.touchObject.startY ? 1 : -1), o = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, r.options.infinite === !1 && (0 === r.currentSlide && "right" === i || r.currentSlide >= r.getDotCount() && "left" === i) && (o = r.touchObject.swipeLength * r.options.edgeFriction, r.touchObject.edgeHit = !0), r.options.vertical === !1 ? r.swipeLeft = e + o * s : r.swipeLeft = e + o * (r.$list.height() / r.listWidth) * s, r.options.verticalSwiping === !0 && (r.swipeLeft = e + o * s), r.options.fade !== !0 && r.options.touchMove !== !1 && (r.animating === !0 ? (r.swipeLeft = null, !1) : void r.setCSS(r.swipeLeft))) : void 0)
        }, e.prototype.swipeStart = function(t) {
            var e, i = this;
            return i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? (i.touchObject = {}, !1) : (void 0 !== t.originalEvent && void 0 !== t.originalEvent.touches && (e = t.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== e ? e.pageX : t.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== e ? e.pageY : t.clientY, void(i.dragging = !0))
        }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
            var t = this;
            null !== t.$slidesCache && (t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.appendTo(t.$slideTrack), t.reinit())
        }, e.prototype.unload = function() {
            var e = this;
            t(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
        }, e.prototype.unslick = function(t) {
            var e = this;
            e.$slider.trigger("unslick", [e, t]), e.destroy()
        }, e.prototype.updateArrows = function() {
            var t, e = this;
            t = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
        }, e.prototype.updateDots = function() {
            var t = this;
            null !== t.$dots && (t.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
        }, e.prototype.visibility = function() {
            var t = this;
            t.options.autoplay && (document[t.hidden] ? t.interrupted = !0 : t.interrupted = !1)
        }, t.fn.slick = function() {
            var t, i, o = this,
                s = arguments[0],
                n = Array.prototype.slice.call(arguments, 1),
                r = o.length;
            for (t = 0; t < r; t++)
                if ("object" == typeof s || "undefined" == typeof s ? o[t].slick = new e(o[t], s) : i = o[t].slick[s].apply(o[t].slick, n), "undefined" != typeof i) return i;
            return o
        }
    });